<script>
import ConfirmArea from "@/components/atoms/ConfirmArea";
import Terms from "@/components/atoms/Terms";
import Connecting from "@/components/atoms/Connecting";

export default {
  components: { ConfirmArea, Terms, Connecting },
  created() {
    // Save Logs
    let current_log = console.log;
    const log = console.log;
    console.log = (msg) => {
      try{
        if (msg !== undefined) this.console_data.push(msg);
        current_log.apply(null, arguments);
        this.$store.dispatch("postMessage", "log:"+ JSON.stringify(msg));
        log(msg);
      }catch(e){
        log(e);
      }
    };
    const error = console.error;
    console.error = (err) => {
      try{
        if (err !== undefined) this.console_data.push(err);
        current_log.apply(null, arguments);
        this.$store.dispatch("postMessage", "error:"+JSON.stringify(err));
        this.mixpanel.track('Error Web', {
          ...err
        });
        error(err);
      }catch(e){
        error(e);
      }
    };

    this.$store.dispatch("parts/loadParts", null, {root: true});

    // Vr Hover
    if (window.vuplex) {
      this.addMessageListener();
    } else {
      window.addEventListener('vuplexready', this.addMessageListener);
    }

    this.mixpanel.track('User Active');

    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
      this.$store.set('mobile', true);
      this.mixpanel.track('Using Mobile');
    }

    if(!window.navigator.onLine){
      this.$store.commit('confirm', {
        title: "You're Offline",
        description: "Some features will be unavailable until you come back online.",
        stop_label: "NONE",
        start_label: "Continue",
        start: ()=>{},
        stop: ()=>{}
      })
    }
    window.addEventListener('offline', () => {
      this.$store.commit('confirm', {
        title: "You're Offline",
        description: "Some features will be unavailable until you come back online.",
        stop_label: "NONE",
        start_label: "Continue",
        start: ()=>{},
        stop: ()=>{}
      })
    });
    window.addEventListener('online', () => {
      this.$store.commit('confirm', {
        title: "You're Back Online",
        description: "All features are now available.",
        stop_label: "NONE",
        start_label: "Continue",
        start: ()=>{},
        stop: ()=>{}
      })
    });
    // window.addEventListener("keydown", (event) => {
    //   // this.scroll({x: 1, y: 0})
    //   if(event.code == "ArrowLeft"){
    //     console.log("CALLED");
    //     const key_callback = this.$store.state.key_callback;
    //     key_callback("BACK")
    //   }
    // });
    // window.addEventListener('mousemove', (e) => {
    //   // console.log({x: e.clientX, y: e.clientY})
    //   this.hover({x: e.clientX, y: e.clientY});
    // });
  },
  mounted(){
    this.$store.set('payment/showConnectingToStripe', false);
  },
  data() {
    return {
      last_hover: null,
      last_data_vr: null,
      console_data: [],
      mouse_x: 0,
      mouse_y: 0,
    };
  },
  computed: {
    UseMetric(){
      return this.$store.get('useMetric');
    },
    roundLength(){
      return this.$store.get('roundLength');
    },
    roundPosition(){
      return this.$store.get('roundPosition');
    },
    roundLengthInchIncrement(){
      return this.$store.get('roundLengthInchIncrement');
    },
    roundLengthMeterIncrement(){
      return this.$store.get('roundLengthMeterIncrement');
    },
    roundPositionInchIncrement(){
      return this.$store.get('roundPositionInchIncrement');
    },
    roundPositionMeterIncrement(){
      return this.$store.get('roundPositionMeterIncrement');
    },
  },
  watch: {
    UseMetric(value){
      this.$store.dispatch("postMessage", "useMetric:"+value);
    },
    roundLength(value){
      this.$store.dispatch("postMessage", "roundLength:"+value);
    },
    roundPosition(value){
      this.$store.dispatch("postMessage", "roundPosition:"+value);
    },
    roundLengthInchIncrement(value){
      this.$store.dispatch("postMessage", "roundLengthInchIncrement:"+value)
    },
    roundLengthMeterIncrement(value){
      this.$store.dispatch("postMessage", "roundLengthMeterIncrement:"+value)
    },
    roundPositionInchIncrement(value){
      this.$store.dispatch("postMessage", "roundPositionInchIncrement:"+value)
    },
    roundPositionMeterIncrement(value){
      this.$store.dispatch("postMessage", "roundPositionMeterIncrement:"+value)
    }
  },
  methods: {
    addMessageListener(){
      this.$store.dispatch("postMessage", "finishedLoading:"+true);
      setTimeout(() => { // Back up
        this.$store.dispatch("postMessage", "finishedLoading:"+true);
      }, 5000)
      this.mixpanel.track('Using VR');
      this.$store.set('vr', true);
      window.vuplex.addEventListener("message", (event) => {
        let json = JSON.parse(event.data);
        if (json.type == "position") {
          this.hover(json);
        } else if (json.type == "secondaryThumbstick") {
          this.scroll(json);
        } else if (json.type == "grab") {
          console.log("grab");
        } else if(json.type == "save"){
          this.mixpanel.track('Save Project', {projectId: json.data.id});
          this.$store.dispatch("saveFiles/saveFile", json.data)
        } else if(json.type == "saving"){
          this.$store.commit('saveFiles/saving', true);
        } else if(json.type == "goto"){
          this.$router.push(json.path)
        }else if(json.type == "key"){ // DEPRECATED
          const key_callback = this.$store.state.key_callback;
          if(key_callback instanceof Function){
            key_callback(json.key)
          }
        }else if(json.type == "image"){
          this.$store.dispatch("saveFiles/saveImage", {
            base64String: json.data,
            name: json.name,
          });
        }else if(json.type == "glb"){
          this.$store.dispatch("saveFiles/saveGlb", {
            base64String: json.data,
            name: json.name,
          });
        }else if(json.type == "loaded"){
          this.mixpanel.track('Load Project', {projectId: json.id});
          this.$store.commit("saveFiles/loaded", json.id);
        }else if(json.type == "confirmLoad"){
          this.$store.dispatch("saveFiles/confirmLoad", {id: json.id, name: json.name});
        }else if(json.type == "confirmNewProject"){
          this.$store.dispatch("saveFiles/confirmNewProject");
        }else if(json.type == "mixpanel"){
          if(json.name){
            this.mixpanel.track(json.name, json.data ? json.data : {});
          }
        }else if(json.type == "clearHighlightedParts"){
          this.$store.commit("parts/highlightedParts", false);
        }
      });
    },
    hover(json){
      this.mouse_x = Number(json.x);
      this.mouse_y = Number(json.y);
      const hovering = document.elementFromPoint(
        this.mouse_x,
        this.mouse_y
      );
      if (this.last_hover !== hovering) {
        if (this.last_hover) {
          this.last_hover.classList.remove("hover");
        }
        this.last_hover = hovering;
        hovering.classList.add("hover");

        if (hovering.hasAttribute("data-vr")) {
          this.last_data_vr = hovering.getAttribute("data-vr");
          this.$store.dispatch("postMessage", "ID:"+this.last_data_vr);
        }else{
          this.$store.dispatch("postMessage", "ID:null");
        }
      }
    },
    scroll(json){
      if(this.$store.get("openDrawer") && (this.mouse_x && this.mouse_x < 480) && this.$store.get('refs')["drawer"]){
        this.$store.get('refs')["drawer"].scrollBy(
          {
            dy: -json.y*20
          },
          500
        );
      }else{
        if(Math.abs(json.x) > Math.abs(json.y)){
          const parent = this.getScrollParentX(this.last_hover);
          if(parent){
            parent.scrollBy(json.x*20, 0);
          }
        }else{
          const parent = this.getScrollParentY(this.last_hover);
          if(parent){
            parent.scrollBy(0, -json.y*20);
          }
        }
      }
    },
    getScrollParentX(node) {
      if (node == null) {
        return window;
      }
      if (node.classList.contains("__panel")) {
        return node;
      } else {
        return this.getScrollParentX(node.parentNode);
      }
    },
    getScrollParentY(node) {
      if (node == null) {
        return window;
      }

      if (node.scrollHeight > node.clientHeight + 40) {
        return node;
      } else {
        return this.getScrollParentY(node.parentNode);
      }
    },
    clearPopups(){
      this.$store.commit('saveFiles/saving', false)
      this.$store.commit('saveFiles/saved', false)
      this.$store.commit('saveFiles/saving_error', null)
    }
  }
};
</script>

<template>
  <div id="app">
    <ConfirmArea id="confirm-area"></ConfirmArea>
    <Terms v-if="$store.get('show_terms_of_use')" link="TermsofUse"/>
    <Terms v-if="$store.get('show_privacy_policy')" link="PrivacyPolicy"/>
    <Connecting v-if="$store.get('payment/showConnectingToStripe')" />
    <transition name="fade-loading">
      <div class="overlay" v-if="$store.get('saveFiles/saving') || $store.get('saveFiles/saved') || $store.get('saveFiles/saving_error')" @click="clearPopups">
        <div class="module saving" v-if="$store.get('saveFiles/saving_error')">
          <i class="fas fa-times"></i>
          <div class="text">
            Unable To Save Project
          </div>
          <div class="sub-text">
            {{$store.get('saveFiles/saving_error')}}
          </div>
        </div>
        <div class="module saved" v-else-if="$store.get('saveFiles/saved')">
          <i class="fas fa-box-check"></i>
          <div class="saved">
            Saved Successfully
          </div>
        </div>
        <div class="module saving splash" v-else-if="$store.get('saveFiles/saving')">
          <img class="press" :src="'./images/TakeAPicture.png'" />
          <div class="text">
            Take a picture of your project
          </div>
          <div class="sub-text">
            Press the right index trigger
          </div>
        </div>
      </div>
    </transition>
    <div v-if="false" class="console">
      <div v-for="(line, index) in console_data" :key="index">
        {{line}}
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');
@import "~@/styles/constants";
html {
  width: 100%;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
  font-size: 14px;
  body {
    width: 100%;
    min-height: 100%;
    margin: 0px;
    padding: 0px;
    font-family: "Montserrat", sans-serif;
    color: $w;
    background: $page_background;
    .Vue-Toastification__container{
      font-weight: 600;
    }
    .__panel{
      scrollbar-width: none;
    }
    #app {
      width: 100%;
      height: 100%;
      font-weight: 600;
      .fraction{
        font-size: 0.8em;
      }
      .series-label{
        &.s20{
          background-color: $r;
        }
        &.s25{
          background-color: $g;
          &.s40{
            background: linear-gradient(122deg, $g 50%, $t 50%);
          }
        }
        &.s30{
          background-color: $y;
        }
        &.s40{
          background-color: $t;
        }
        &.s45{
          background-color: $v;
        } 
        &.s10{
          background-color: $b;
        }
        &.s15{
          background-color: $p;
          &.s40{
            background: linear-gradient(122deg, $p 50%, $t 50%);
            &.s30{
              background: linear-gradient(122deg, $y 33%, $p 33%, $p 66%, $t 66%);
            }
          }
        }
        &.s10{
          &.s15{
            background: linear-gradient(122deg, $b 50%, $p 50%);
          }
          &.s25{
            background: linear-gradient(122deg, $b 50%, $g 50%);
          }
        }
        &.sMetric{
          background: $black_4;
        }
        &.sFractional{
          background: $black_4;
        }
        .icon{
          height: 100%;
          margin-right: 0.75rem;
        }
      }
      .overlay{
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 100;
        .module{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 0.5rem;
          padding: 3rem;
          margin-bottom: 4rem;
          &.splash{
            padding: 5rem 6rem;
          }
          &.saving{
            background-color: #444;
          }
          &.saved{
            background-color: #48c586;
          }
          .press{
            width: 15rem;
            margin-bottom: 4rem;
          }
          .text{
            font-size: 2rem;
            margin-bottom: 1.5rem;
          }
          .sub-text{
            font-size: 1.25rem;
          }
          .fas{
            font-size: 3rem;
            margin-bottom: 1.5rem;
            // color: #64f7ad;
          }
          .saved{
            font-size: 2rem;
            // color: #64f7ad;
          }
          .create-project{
            // padding: 2rem 3rem;
            width: 30rem;
            .create-project-title{
              font-size: 1.5rem;
              margin-bottom: 1rem;
            }
            .input{
              margin-bottom: 1rem;
          }
          }
        }
      }
      .save-module{
        padding-bottom: 4rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 110rem;
        flex-basis: 110rem;
        margin: 0rem 1rem;
        .save-file-container{
          width: 100%;
        }
        .save-container{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
        }
        .save-title{
          font-size: 2rem;
          margin: 2rem 2rem 0rem 2rem;
          .fa{
            margin-right: 0.25rem;
            // color: $p;
          }
        }
        .input{
          margin-bottom: 1rem;
        }
        .project-name{
          font-size: 1.5rem;
        }
        .new-project{
          flex-basis: 30rem;
          height: 32rem;
          min-height: 32rem;
          display: flex;
          align-items: center;
          flex-direction: row;
          margin: 1rem;
          // margin-top: 3rem;
          border-radius: 0.5rem;
          transition: transform 0.3s ease;
          box-shadow: $z_depth_2;
          background-color: $card_background;
          transition: background-color 0.1s ease;
          &.add-name{
            &:hover, &.hover{
              transform: scale(1);
            }
            * {
              pointer-events: auto;
            }
          }
          &:hover, &.hover{
            background-color: rgba(178, 99, 247, 0.8);
            transform: scale(1.025);
            cursor: pointer;
          }
          * {
            pointer-events: none;
          }
        }
        .new-button{
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 1.75rem;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          .fa{
            font-size: 3rem;
            margin-bottom: 1rem;
          }
        }
      }
      .fade-loading-enter-active{
        transition: all 0.4s;
      }
      .fade-loading-leave-active{
        transition: all 0.2s;
      }
      .fade-loading-enter{
        opacity: 0;
      }
      .fade-loading-leave-to{
        opacity: 0;
      }
    }
  }
  .pac-container{
    background-color: $black_2;
    &::after{
      display: none;
      opacity: 0;
    }
    .pac-item{
      color: $w_1;
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      font-size: 1rem;
      border-top: 1px solid $black_4;
      height: 3rem;
      display: flex;
      align-items: center;
      font-size: 1.15rem;
      padding: 0rem 1rem;
      &:hover{
        background-color: $black_3;
      }
      .pac-icon{
        color: #FFF;
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
      }
      .pac-item-query{
        color: #FFF;
        font-family: "Montserrat", sans-serif;
        font-weight: 600;
        font-size: 1.15rem;
      }
    }
  }
}
div {
  box-sizing: border-box;
}
.console {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  width: 100vw;
  pointer-events: none;
}
.fade-enter-active {
  transition: all 0.6s;
}
.fade-leave-active {
  transition: all 0.4s;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
</style>
